import { observer } from 'mobx-react-lite';
import { Trash2 } from 'lucide-react';
import Tooltip from '@shared/components/common/Tooltip';
import { useStore } from '@shared/hooks/useStore';
import { formatDateTime } from '@shared/utils/datetime';
import { DATE_TIME_FULL } from '@shared/components/constants/common.constants';

interface ReaderNoteListProps {
    onItemClick: (pageNumber: number) => void,
    onDelete: (id: string) => void
}

const ReaderNoteList = observer(({ onItemClick, onDelete }: ReaderNoteListProps) => {
    const { readerStore } = useStore();

    return (
        <div className='flex flex-col gap-4 text-break'>
            {readerStore.notes.map(note => (
                <div key={note.id} className='flex flex-col text-[11px]'>
                    <div
                        className='cursor-pointer group'
                        onClick={() => onItemClick(note.pageNumber)}
                    >
                        <div className='bg-[#EDE074] p-3 rounded-[2px] mb-1'>
                            <p className='leading-[22px] text-[#121212] line-clamp-3'>
                                {note.highlight}
                            </p>
                        </div>
                        <h4 className='leading-[22px] mb-1 text-[#FFFFFF80] transition-colors'>
                            {note.pageNumber}
                            ページ目
                        </h4>
                        <Tooltip content={note.content} triggerAsChild contentClassName='max-w-[320px] whitespace-pre-line text-break'>
                            <p className='leading-[22px] text-[#FFFFFFCC] line-clamp-3 whitespace-pre-line'>
                                {note.content}
                            </p>
                        </Tooltip>
                    </div>
                    <div className='flex justify-between items-center'>
                        <span className='leading-[22px] text-[#FFFFFF80]'>{formatDateTime(note.createdAt, DATE_TIME_FULL)}</span>
                        <button
                            onClick={() => onDelete(note.id)}
                            className='text-white transition-colors'
                        >
                            <Trash2 size={16} />
                        </button>
                    </div>
                    <div className='h-[1px] bg-[#FFFFFF1A] mt-4' />
                </div>
            ))}

            {readerStore.notes.length < readerStore.noteTotal && (
                <button
                    onClick={() => readerStore.fetchNotes(true)}
                    disabled={readerStore.isFetchingNotes}
                    className='w-full py-2 bg-[#FFFFFF0A] hover:bg-[#FFFFFF1A] transition-colors rounded-[4px] text-[13px] font-medium'
                >
                    {readerStore.isFetchingNotes ? '読み込み中...' : 'もっと見る'}
                </button>
            )}
        </div>
    );
});

export default ReaderNoteList;
